import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faGithub, faLinkedin 
} from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faPaperPlane, faUser, faComment } from '@fortawesome/free-solid-svg-icons';
import './Contact.css';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });
    
    const [formStatus, setFormStatus] = useState({
        submitted: false,
        error: false,
        message: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        
        // Create mailto link with form data
        const mailtoLink = `mailto:vishnu.k.ajit@gmail.com?subject=${encodeURIComponent(formData.subject)}&body=${encodeURIComponent(
            `Name: ${formData.name}\nEmail: ${formData.email}\n\nMessage:\n${formData.message}`
        )}`;
        
        // Open default email client
        window.location.href = mailtoLink;
        
        // Show success message
        setFormStatus({
            submitted: true,
            error: false,
            message: 'Opening your email client...'
        });
        
        // Reset form after a delay
        setTimeout(() => {
            setFormData({ name: '', email: '', subject: '', message: '' });
            setFormStatus({ submitted: false, error: false, message: '' });
        }, 3000);
    };

    return (
        <div className="contact-container">
            <div className="contact-hero">
                <h1>Contact Me</h1>
                <p className="subtitle">
                    Let's connect! Reach out for collaborations, opportunities, or just to say hello.
                </p>
            </div>
            
            <div className="contact-content">
                <div className="contact-social">
                    <a href="https://github.com/YeehawMcfly" target="_blank" rel="noopener noreferrer" className="social-icon">
                        <FontAwesomeIcon icon={faGithub} />
                        <span>GitHub</span>
                    </a>
                    <a href="https://www.linkedin.com/in/vishnu-ajit-a56760283/" target="_blank" rel="noopener noreferrer" className="social-icon">
                        <FontAwesomeIcon icon={faLinkedin} />
                        <span>LinkedIn</span>
                    </a>
                    <a href="mailto:vishnu.k.ajit@gmail.com" className="social-icon">
                        <FontAwesomeIcon icon={faEnvelope} />
                        <span>Email</span>
                    </a>
                </div>
                
                <div className="contact-info">
                    <p>Feel free to reach out to me through any of the channels above or by using the form below. I'm always open to discussing new projects, creative ideas, or opportunities to be part of your vision.</p>
                </div>
                
                <div className="contact-form-container">
                    <form onSubmit={handleSubmit} className="contact-form">
                        {formStatus.submitted && (
                            <div className={`form-message ${formStatus.error ? 'error' : 'success'}`}>
                                {formStatus.message}
                            </div>
                        )}
                        
                        <div className="form-group">
                            <label htmlFor="name">
                                <FontAwesomeIcon icon={faUser} />
                                <span>Name</span>
                            </label>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                                placeholder="Your name"
                            />
                        </div>
                        
                        <div className="form-group">
                            <label htmlFor="email">
                                <FontAwesomeIcon icon={faEnvelope} />
                                <span>Email</span>
                            </label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                                placeholder="your.email@example.com"
                            />
                        </div>
                        
                        <div className="form-group">
                            <label htmlFor="subject">
                                <FontAwesomeIcon icon={faComment} />
                                <span>Subject</span>
                            </label>
                            <input
                                type="text"
                                id="subject"
                                name="subject"
                                value={formData.subject}
                                onChange={handleChange}
                                required
                                placeholder="What's this about?"
                            />
                        </div>
                        
                        <div className="form-group">
                            <label htmlFor="message">
                                <FontAwesomeIcon icon={faComment} />
                                <span>Message</span>
                            </label>
                            <textarea
                                id="message"
                                name="message"
                                value={formData.message}
                                onChange={handleChange}
                                required
                                rows="6"
                                placeholder="Your message here..."
                            ></textarea>
                        </div>
                        
                        <button type="submit" className="submit-button">
                            <FontAwesomeIcon icon={faPaperPlane} /> Send Message
                        </button>
                        
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Contact;